type QuantityInputGroupErrorProps = {
  error:
    | {
        count: string
      }[]
    | undefined
  submitError: string | undefined
  touched: boolean | undefined
}
const QuantityInputGroupError = ({
  error: formError,
  submitError,
  touched
}: QuantityInputGroupErrorProps) => {
  const error = formError?.find((e) => e.count)?.count || submitError
  const showError = (touched || submitError) && !!error

  if (!error || !showError) return null
  return (
    showError && (
      <p className="text-sm italic text-red-500 font-light mt-1">{error}</p>
    )
  )
}

export default QuantityInputGroupError
